import { render, staticRenderFns } from "./quote-refer.vue?vue&type=template&id=6dd651fb&scoped=true&"
import script from "./quote-refer.vue?vue&type=script&lang=js&"
export * from "./quote-refer.vue?vue&type=script&lang=js&"
import style0 from "./quote-refer.vue?vue&type=style&index=0&id=6dd651fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd651fb",
  null
  
)

export default component.exports